<template>
    <div class="content-block dx-card">
        <h2>Support Tickets</h2>
    </div>
    <div v-if="loading" class="loading-overlay">
        LOADING...
        <span class="loader"></span>
    </div>
    <div v-else>

    <div class="content-block dx-card" id="dataDiv">
        <DxDataGrid :data-source="tickets" :key-expr="ticketId" :hover-state-enabled="true"
            :selection="{ mode: 'multiple', showCheckBoxesMode: 'always', selectAllMode: 'page' }" :show-borders="true" :columns-auto-width="true" :column-min-width="50"
            :allow-column-resizing="true" :column-resizing-mode="columnResize" :allow-column-reordering="true"
            :filter-builder="filterBuilder" :filter-value="filterValue" :style="{ 'max-height': datagridHeight }"
            no-data-text="No data." @initialized="saveGridInstance" @exporting="onExporting" @row-click="loadTicketData" @selection-changed="onSelectionChanged"
            >
            <!-- @cell-prepared="onDataGridCellPrepared" -->

            <DxLoadPanel :enabled="true" />
            <DxColumnChooser :enabled="true" mode="select" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />
            <DxScrolling mode="standard" />
            <DxExport :enabled="true" />
            <DxColumnFixing :enabled="true" />
            <DxPager :show-info="true" :show-page-size-selector="true" :allowed-page-sizes="[20, 50, 100]"
                :show-navigation-buttons="true" />
            <DxStateStoring :enabled="true" type="localStorage" storage-key="support-tickets-grid" />
            <DxToolbar>
                <DxItem location="before" template="actionsTemplate" />
                <DxItem location="before" template="selectionCountTemplate" />
                <DxItem location="after" name="columnChooserButton" />
                <DxItem location="after" template="refreshRecordTemplate" />
                <DxItem location="after" template="removeFilterRecordTemplate" />
                <DxItem location="after" name="exportButton" />
            </DxToolbar>

            <template #selectionCountTemplate>
                <span v-if="selectedCount > 0" style="color: darkorange; font-weight: 500; padding: 0 8px;">
                    {{ selectedCount }} selected
                </span>
            </template>
            <template #actionsTemplate>
                <DxDropDownButton
                    text="Actions"
                    :items="actionsMenu"
                    display-expr="text"
                    :drop-down-options="{ width: 160 }"
                    @item-click="onActionItemClick"
                />
            </template>
            <template #refreshRecordTemplate>
                <DxButton icon="refresh" @click="refreshData" />
            </template>
            <template #removeFilterRecordTemplate>
                <DxButton icon="filter" @click="removeFilter" />
            </template>
            
            <DxColumn data-field="statusName" cell-template="grid-cell" />
            <DxColumn data-field="ticketId" caption = "Id" />
            <DxColumn data-field="typeName" />
            <DxColumn data-field="tank" />
            <DxColumn data-field="containerId" caption="Tank Id" visible="false"/>
            <DxColumn data-field="deviceId" visible="false"/>
            <DxColumn data-field="createdTime" />
            <DxColumn data-field="resolvedTime" />
            <DxColumn data-field="requestInfo" caption="Request Info" :calculate-cell-value="(rowData) => formatRequestInfoText(rowData.requestInfo)" />
            <DxColumn data-field="user" />
            <DxColumn data-field="device" />
            <DxColumn data-field="operator" />
            <DxColumn data-field="area" />
            <DxColumn data-field="downholeLSD" visible="false"/>
            <DxColumn data-field="alias" visible="false"/>
            
            <template #grid-cell="{ data }">
                <div style="margin-top: -15px;margin-bottom: -20px;">
                    <div :style="'cursor: pointer; display: flex; align-items:center; justify-content: center; background-color: ' + getStatusColor(data.value)+ '; border-radius: 30px; padding:6px; outline: 1px solid #707070 ;'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                            <path d="M0 0h48v48h-48z" fill="none"/>
                            <path fill="#ffffff" d="M28 4h-16c-2.21 0-3.98 1.79-3.98 4l-.02 32c0 2.21 1.77 4 3.98 4h24.02c2.21 0 4-1.79 4-4v-24l-12-12zm4 28h-6v6h-4v-6h-6v-4h6v-6h4v6h6v4zm-6-14v-11l11 11h-11z"/>
                        </svg>
                        <span style="padding-left: 10px;">{{ data.value }}</span>
                    </div>  
                </div>    
            </template>
        </DxDataGrid>
    </div>

    <DxLoadPanel v-model:visible="loadingVisible" :message="Loading" :show-indicator="true" :show-pane="true"
        :shading="true" :hide-on-outside-click="false" :on-shown="onLoadPanelShown" :on-hidden="onLoadPanelHidden"
        shading-color="rgba(0,0,0,0.4)" />

    <DxPopup
        v-model:visible="updateStatusPopupVisible"
        width="400px"
        height="auto"
        :hide-on-outside-click="false"
        :show-close-button="true"
        title="Update Status"
    >
        <template #content>
            <div style="padding: 20px; display: flex; flex-direction: column; gap: 20px;">
                <div style="color: darkorange; font-weight: 500;">{{ selectedCount }} ticket{{ selectedCount !== 1 ? 's' : '' }} selected</div>
                <DxSelectBox
                    label="New Status"
                    label-mode="floating"
                    :items="ticketStatuses"
                    display-expr="statusName"
                    value-expr="ticketStatusId"
                    v-model:value="bulkNewStatus"
                />
                <div style="display: flex; justify-content: center;">
                    <DxButton text="Confirm" type="default" styling-mode="contained" @click="onClick_ConfirmUpdateStatus" />
                </div>
            </div>
        </template>
    </DxPopup>
    
    <DxPopup
        v-model:visible="notesVisible"
        width="60%"
        height="600px"
        :hide-on-outside-click="false"
        :show-close-button="true"
        title="Notes"
        :resize-enabled="true"
    >
        <template #content>
            <div
                style="
                    margin-top: 10px;
                    background-color: #363640;
                    /* border-top: 1px solid #515159; */
                    border-bottom: 1px solid #515159;
                    /* padding: 40px; */
                    font-size: 16px;
                    height: 95%;
                    overflow-y: auto;
                    scrollbar-color: darkorange #303030;
                ">
                    <div style="padding-bottom: 20px;">
                        <div style="font-size: 36px; font-weight: 100;">{{ currentTicket.typeName }} </div>
                        <div class="note-header">Ticket Id: {{  currentTicket.ticketId }} </div>
                        <div class="note-header">Created: {{ currentTicket.createdTime }} </div>
                        <div class="note-header">By: {{ currentTicket.user }} </div>
                        <div style="padding-top: 10px; font-size: 14px; font-weight: 100;">
                            <div>Site: {{ currentTicket.surface }} / {{ currentTicket.device }} </div>
                            <div v-for="(item, idx) in formatRequestInfo(currentTicket.requestInfo)" :key="idx">
                                {{ item.label }}: {{ item.value }}
                            </div>
                        </div>
                    </div>

                    <div>
                        <DxHtmlEditor v-model:value="newNoteText" height="200px" 
                        Placeholder="Optional: Add note here.">
                        <!-- <DxHtmlEditor height="200px"> -->
                            <DxMediaResizing :enabled="false" />
                            <DxImageUpload :enabled="false" />
                            <DxToolbar :multiline="false">
                                <DxItem name="bold" />
                                <DxItem name="italic" />
                                <DxItem name="strike" />
                                <DxItem name="underline" />
                                <DxItem name="separator" />
                                <DxItem name="alignLeft" />
                                <DxItem name="alignCenter" />
                                <DxItem name="alignRight" />
                                <DxItem name="separator" />
                                <DxItem name="orderedList" />
                                <DxItem name="bulletList" />
                                <DxItem name="separator" />
                                <DxItem name="color" />
                                <DxItem name="background" />
                            </DxToolbar>
                        </DxHtmlEditor>
                    </div>
                    <!-- <DxButton class="btn-medium" icon="save" text="Save" @click="saveNote" /> -->
                     <div style="padding-top:10px; padding-bottom: 20px; display: flex; align-items:center; justify-content: center;">
                        <div style="padding-right: 40px;">
                            <DxSelectBox
                                label="Status Change?"
                                label-mode="floating"
                                :search-enabled="true"
                                :items="ticketStatuses"
                                display-expr="statusName"
                                value-expr="ticketStatusId"
                                v-model:value="newStatus"
                            />
                        </div>
                        <div style="width: 400px; cursor: pointer; display: flex; align-items:center; justify-content: center; background-color:darkorange; color: black; border-radius: 10px; padding:6px; outline: 1px solid #707070 ;"
                            @click="onClick_SaveNote()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                                <path d="M0 0h48v48h-48z" fill="none"/>
                                <path fill="#000000" d="M28 4h-16c-2.21 0-3.98 1.79-3.98 4l-.02 32c0 2.21 1.77 4 3.98 4h24.02c2.21 0 4-1.79 4-4v-24l-12-12zm4 28h-6v6h-4v-6h-6v-4h6v-6h4v6h6v4zm-6-14v-11l11 11h-11z"/>
                            </svg>
                            <span style="padding-left: 10px;">Save Changes</span>
                        </div>

                    </div>
                
                    <div v-for="note in notes" :key="note.ticketNoteId">
                        <div class="note">
                            <div class="note-header">
                                <!-- <DxButton icon="edit" location="after" @click="editNote(note.phaseNoteId)" /> -->
                                {{ note.createdTime }} : {{ note.user }}
                                <!-- <span class="note-userinfo"> ( {{ note.createdBy }} ) </span> -->
                            </div>
                            <div v-html="note.noteText"></div>
                        </div>

                        <!-- <hr style="height: 1px; border: 1px solid #444" /> -->
                    </div>
                    

            </div>           
        </template>
    </DxPopup>
    </div>
</template>

<script>
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxColumnFixing,
    DxPager,
    DxItem,
    DxToolbar,
    DxExport,
    DxStateStoring,
    // DxButton as DxDataGridButton
} from "devextreme-vue/data-grid";
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxButton } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import { DxPopup } from 'devextreme-vue/popup';
import {
  DxHtmlEditor,
  DxMediaResizing,
  DxImageUpload,
} from 'devextreme-vue/html-editor'

export default {
    components: {
        DxDataGrid,
        DxSelectBox,
        // DxDataGridButton,
        DxColumn,
        DxHeaderFilter,
        DxFilterRow,
        DxScrolling,
        DxColumnChooser,
        DxLoadPanel,
        DxButton,
        DxToolbar,
        DxItem,
        DxExport,
        DxColumnFixing,
        DxPager,
        DxStateStoring,
        DxPopup,
        DxHtmlEditor,
        DxMediaResizing,
        DxImageUpload,
        // eslint-disable-next-line
        DxDropDownButton,
    },
    created() {
        this.loadPageData();
    },
    mounted() {
        window.addEventListener("resize", this.setDimensions);
        this.setDimensions();
    },
    unmounted() {
        window.removeEventListener("resize", this.setDimensions);
    },
    data() {
        return {
            loading: true,
            columnResize: "widget",
            dataGridInstance: null,
            loadingVisible: false,
            isLoadPanelVisible: false,
            datagridHeight: "40vh",
            notesVisible: false,
            currentTicket: null,
            newStatus: null,
            newNoteText: "",
            actionsMenu: [{ text: 'Update Status', id: 'update-status' }],
            updateStatusPopupVisible: false,
            bulkNewStatus: null,
            selectedCount: 0,
        };
    },
    computed: {
        tickets() {
            const tickets = this.$store.getters["support/getTickets"]
            
            const typesMap = new Map();
            const types = this.$store.getters["support/getTicketTypes"]
            for(const key in types)
                {typesMap.set(types[key].ticketTypeId, types[key].typeName)}
            
            const statusMap = new Map();
            const statuses = this.$store.getters["support/getTicketStatuses"]
            for(const key in statuses)
                {statusMap.set(statuses[key].ticketStatusId, statuses[key].statusName)}

            const usersMap = new Map();
            const users = this.$store.getters["users/getUsers"]
            for(const key in users)
                {usersMap.set(users[key].userId, users[key].userName)}

            for(const key in tickets)
            {
                const containerInfo = JSON.parse(tickets[key].containerInfo)
                tickets[key]['typeName'] = typesMap.get(tickets[key].ticketTypeId)
                tickets[key]['statusName'] = statusMap.get(tickets[key].ticketStatusId)
                tickets[key]['tank'] = containerInfo.containerName
                tickets[key]['device'] = containerInfo.serialnum
                tickets[key]['user'] = usersMap.get(tickets[key].userId)
                tickets[key]['operator'] = containerInfo.operatorName
                tickets[key]['area'] = containerInfo.areaName
                tickets[key]['downholeLSD'] = containerInfo.properties?.find(p => p.propertyName === "Downhole LSD")?.propValue ?? '';
                tickets[key]['alias'] = containerInfo.properties?.find(p => p.propertyName === "Alias")?.propValue ?? '';

                tickets[key].createdTime = this.formatDate(tickets[key].createdTime)
                tickets[key].resolvedTime = this.formatDate(tickets[key].resolvedTime)
                if (tickets[key].createdTime == tickets[key].resolvedTime)
                    tickets[key].resolvedTime = ''
            }
            // console.log(tickets)
            return tickets
        },
        ticketTypes() {
            return this.$store.getters["support/getTickets"]
        },
        ticketStatuses() {
            return this.$store.getters["support/getTicketStatuses"]
        },
        users() {
            return this.$store.getters["users/getUsers"]
        },
        notes() {
            const notes = this.$store.getters["support/getTicketNotes"]

            const usersMap = new Map();
            const users = this.$store.getters["users/getUsers"]
            for(const key in users)
                {usersMap.set(users[key].userId, users[key].userName)}
            
            for(const key in notes)
            {
                notes[key]['user'] = usersMap.get(notes[key].userId)
                notes[key].createdTime = this.formatDate(notes[key].createdTime)

            }
            return notes
        }
    },
    methods: {
        onLoadPanelShown() { },
        onLoadPanelHidden() { },
        saveGridInstance: function (e) {
            this.dataGridInstance = e.component;
        },
        setDimensions() {
            const h = document.documentElement.clientHeight;
            this.datagridHeight = h - 250 + "px";
        },
        removeFilter() {
            this.dataGridInstance.clearFilter();
            this.dataGridInstance.clearSorting();
        },
        refreshData() {
            this.loadPageData();
        },
        
        async loadPageData(refresh = false) {
            this.loading = true;
            this.loadingVisible = true;
            try {
                await Promise.all([
                    this.$store.dispatch("users/loadUsers"),
                    this.$store.dispatch("support/loadTicketTypes"),
                    this.$store.dispatch("support/loadTicketStatuses"),
                    this.$store.dispatch("support/loadTickets")
                ]);
            } catch (error) {
                this.error = error.message || "Unexpected Error.";
            } finally {
                this.loading = false;
                this.loadingVisible = false;
            }
        },

        formatDate(date) {
            if (!date) return "";
            const formattedDate = new Date(date);

           
            const year = String(formattedDate.getFullYear())
            // getMonth() returns 0-indexed month, so add 1
            const month = String(formattedDate.getMonth() + 1).padStart(2, '0')
            const day = String(formattedDate.getDate()).padStart(2, '0')
            const time = formattedDate.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })

            return `${year}-${month}-${day} ${time}`           
        },
        onExporting(e) {
            e.fileName = `SupportTicketsDataExport_${new Date().toISOString().slice(0, 10)}`;
        },
        formatRequestInfo(requestInfo) {
            if (!requestInfo) return [];

            let info;
            try {
                info = JSON.parse(requestInfo);
            } catch (error) {
                return [{ label: "Info", value: requestInfo }];
            }

            return Object.entries(info).map(([key, value]) => ({
                label: this.formatRequestInfoLabel(key),
                value,
            }));
        },
        formatRequestInfoLabel(key) {
            const spaced = key.replace(/([a-z])([A-Z])/g, "$1 $2");
            return spaced.charAt(0).toUpperCase() + spaced.slice(1);
        },
        formatRequestInfoText(requestInfo) {
            return this.formatRequestInfo(requestInfo)
                .map((item) => `${item.label}: ${item.value}`)
                .join(", ");
        },
        getStatusColor(status) {
            if (status=='New')
                return "#8B0000"
            if (status=='In Progress')
                return "#AAA520"
            if (status=='Resolved')
                return "#006400"
            
            return "#404040"
        },
        async loadTicketData(e) {
            this.currentTicket = e.data;
            const id = this.currentTicket.ticketId;
            this.loadingVisible = true;
            this.notesVisible = true;
            
            try {
                await Promise.all([
                    this.$store.dispatch("support/loadTicketNotes", { ticketId: id })
                ]);
            } catch (error) {
                this.error = error.message || "Unexpected Error.";
            }
            this.loadingVisible = false;
        },
        onSelectionChanged(e) {
            this.selectedCount = e.selectedRowsData.length;
        },
        onActionItemClick(e) {
            if (e.itemData.id === 'update-status') {
                const selected = this.dataGridInstance.getSelectedRowsData();
                if (!selected.length) return;
                this.bulkNewStatus = null;
                this.updateStatusPopupVisible = true;
            }
        },
        async onClick_ConfirmUpdateStatus() {
            if (!this.bulkNewStatus) return;
            const ticketIds = this.dataGridInstance.getSelectedRowsData().map(t => t.ticketId);
            this.loadingVisible = true;
            try {
                const statusName = this.ticketStatuses.find(s => s.ticketStatusId == this.bulkNewStatus).statusName;
                const promises = ticketIds.map(id =>
                    this.$store.dispatch("support/saveTicketNote", {
                        ticketNoteId: 0,
                        ticketId: id,
                        createdTime: new Date().toISOString(),
                        userId: 0,
                        noteText: `Status changed to ${statusName}`,
                        ticketStatusId: this.bulkNewStatus
                    })
                );
                await Promise.all(promises);
                await this.loadPageData();
            } catch (error) {
                this.error = error.message || 'Unexpected Error.';
            } finally {
                this.loadingVisible = false;
                this.updateStatusPopupVisible = false;
            }
        },
        async onClick_SaveNote() {
            if (!this.newNoteText && !this.newStatus) return;

            this.loadingVisible = true;
            if (!this.newNoteText) {
                const statusName = this.ticketStatuses.find(s => s.ticketStatusId == this.newStatus).statusName;
                this.newNoteText = `Status changed to ${statusName}`;
            }
            var payload =
            {
                ticketNoteId: 0,
                ticketId: this.currentTicket.ticketId,
                createdTime: new Date().toISOString(),
                userId: 0,
                noteText: this.newNoteText,
                ticketStatusId: this.newStatus
            }
            try {
                await this.$store.dispatch("support/saveTicketNote", payload);
                await this.loadPageData();
                this.newNoteText = "";
                this.newStatus = null;
                this.notesVisible = false;
            } catch (error) {
                this.error = error.message || 'Unexpected Error.';
            } finally {
                this.loadingVisible = false;
            }
        },
    },
};
</script>

<style scoped>
    h2 {
        margin-left: 1em;
    }
    .note {
        border-style: solid;
        border-width: 1px;
        /* margin: 20px; */
        border-color: rgb(100, 100, 100);
        border-radius: 3px;
        padding: 20px;
        /* box-shadow:
            0 4px 8px 0 rgba(0, 0, 0, 0.2),
            0 6px 20px 0 rgba(0, 0, 0, 0.19); */
        font-size: 16px;
    }
    .note-header {
        font-family: Roboto, Verdana, Geneva, Tahoma, sans-serif;
        font-weight: 300;
        font-size: 12px;
        color: darkorange;
    }
    .note-userinfo {
        font-family: Roboto, Verdana, Geneva, Tahoma, sans-serif;
        font-weight: 100;
        font-size: 11px;
    }

</style>
